<template>
  <div class="space-y-16">
    <div>
      <RevCheckbox
        id="report-illicit-content-good-faith-certified"
        v-model="values.goodFaithCertified"
      >
        <template #label>
          {{ i18n(translations.goodFaithCertifiedLabel) }}
        </template>
      </RevCheckbox>
      <p
        v-if="errors.goodFaithCertified"
        class="text-action-danger-hi body-2 mt-4"
      >
        {{ errors.goodFaithCertified }}
      </p>
    </div>

    <RevCheckbox
      id="report-illicit-content-is-trusted-flagger"
      v-model="values.isTrustedFlagger"
    >
      <template #label>
        {{ i18n(translations.isTrustedFlaggerLabel) }}
      </template>
    </RevCheckbox>

    <FormattedMessage
      class="body-2 text-static-default-low"
      :definition="translations.privacyPolicyText"
      tag="p"
    >
      <template #privacyPolicy>
        <RevLink target="_blank" :to="privacyLink">
          {{ i18n(translations.privacyPolicyLink) }}
        </RevLink>
      </template>
    </FormattedMessage>
  </div>
</template>

<script lang="ts" setup>
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCheckbox } from '@ds/components/Checkbox'
import { RevLink } from '@ds/components/Link'
import type { Location } from '@ds/types/Location'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { CMS } from '~/scopes/cms/routes-names'
import { LEGAL_PAGE_NAME } from '~/scopes/legal/constants'

import type { ReportIllicitContentFormValues } from '../../../ReportIllicitContent.types'

import translations from './ReportIllicitContentStepDeclaration.translations'

type StepValues = Pick<
  ReportIllicitContentFormValues,
  'goodFaithCertified' | 'isTrustedFlagger'
>

type StepErrors = {
  [K in keyof StepValues]?: string
}

defineProps<{
  errors: StepErrors
}>()

const values = defineModel<StepValues>({ required: true })

const i18n = useI18n()

const resolveLocalizedRoute = useRouteLocationWithLocale()
const privacyLink: Location = resolveLocalizedRoute({
  name: CMS.LEGAL_PAGE,
  params: {
    pageName: LEGAL_PAGE_NAME.DATA_PROTECTION,
  },
})
</script>
